import {
    getCbarCheckboxSubmitValue,
    hydrateCbarCheckboxesIn,
    isCbarCheckbox,
    resolveCbarCheckboxChecked,
    setupCbarCheckboxHydration,
    syncCbarCheckboxSubmitValue,
} from './common/checkbox';

function resolveCheckbox(target: string | Element): CbarCheckboxElement | null {
    const element = typeof target === 'string' ? document.querySelector(target) : target;
    return isCbarCheckbox(element) ? element : null;
}

type CbarCheckboxElement = HTMLElement & {
    checked: boolean;
    value: string;
};

export function setupCbarCheckboxChangeSync(): void {
    document.addEventListener(
        'change',
        (event) => {
            const target = event.target;
            if (target instanceof Element && isCbarCheckbox(target)) {
                syncCbarCheckboxSubmitValue(target);
            }
        },
        true
    );
}

export function setupCbarCheckboxJqueryBridge(): void {
    const jq = (window as Window & { jQuery?: JQueryStatic }).jQuery;
    if (!jq) {
        return;
    }

    const origProp = jq.fn.prop;
    jq.fn.prop = function (this: JQuery, name: unknown, value?: unknown) {
        if (name === 'checked' && value === undefined && this.length > 0) {
            const results: boolean[] = [];
            let hasCheckbox = false;

            for (let i = 0; i < this.length; i++) {
                const el = this[i];
                if (isCbarCheckbox(el)) {
                    hasCheckbox = true;
                    results.push(resolveCbarCheckboxChecked(el));
                }
            }

            if (hasCheckbox) {
                return this.length === 1 ? results[0] : results;
            }
        }

        if (name === 'checked' && value !== undefined) {
            for (let i = 0; i < this.length; i++) {
                const el = this[i];
                if (isCbarCheckbox(el)) {
                    el.checked = Boolean(value);
                    syncCbarCheckboxSubmitValue(el);
                }
            }
            return this;
        }

        return origProp.apply(this, arguments as unknown as [unknown, unknown?]);
    };

    const origVal = jq.fn.val;
    jq.fn.val = function (this: JQuery, value?: unknown) {
        if (value === undefined && this.length > 0) {
            const results: string[] = [];
            let hasCheckbox = false;

            for (let i = 0; i < this.length; i++) {
                const el = this[i];
                if (isCbarCheckbox(el)) {
                    hasCheckbox = true;
                    results.push(getCbarCheckboxSubmitValue(el));
                }
            }

            if (hasCheckbox) {
                return this.length === 1 ? results[0] : results;
            }
        }

        return origVal.apply(this, arguments as unknown as [unknown?]);
    };
}

export function setupCbarCheckboxGlobals(): void {
    window.CBAR = window.CBAR ?? {};
    window.CBAR.getCheckboxChecked = (target: string | Element) => {
        const checkbox = resolveCheckbox(target);
        return checkbox ? resolveCbarCheckboxChecked(checkbox) : false;
    };
    window.CBAR.getCheckboxValue = (target: string | Element) => {
        const checkbox = resolveCheckbox(target);
        return checkbox ? getCbarCheckboxSubmitValue(checkbox) : '';
    };
}

export function setupCbarCheckboxBridge(): void {
    setupCbarCheckboxChangeSync();
    setupCbarCheckboxJqueryBridge();
    setupCbarCheckboxGlobals();
    void setupCbarCheckboxHydration();
}

export {hydrateCbarCheckboxesIn};
